import script from "./GenreSelection16167Option.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenreSelection16167Option.vue?vue&type=script&setup=true&lang=ts"

import "./GenreSelection16167Option.vue?vue&type=style&index=0&id=cfd46500&lang=scss"

const __exports__ = script;

export default __exports__